
import { PaymentIcons } from '../../methods'
import {
  getAdvertisingOptionsFromComponent,
  productPaymentAdvertising,
} from '../helpers/advertising'

export default {
  components: {
    PaymentIcons,
  },

  props: {
    paymentMethods: {
      type: Array,
      required: true,
    },
  },

  computed: {
    advertisedMethods() {
      return productPaymentAdvertising(
        this.paymentMethods,
        getAdvertisingOptionsFromComponent(this),
      ).rest
    },
  },
}
